// extracted by mini-css-extract-plugin
export default {"section_body":"HelpPage_section_body__aGcED","accordion":"HelpPage_accordion__CPGZh","elem_list":"HelpPage_elem_list__cTxrd"};